
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { API_ROUTES } from "@/utils/API";
import { SMCases } from "@/store";
import { APPROVED_BY_HO_OA_STATUS, SPONSOR_LICENCE_SERVICE_TYPE } from "@/constants/services";

const FORM = {
  visa_start_date: null,
  visa_end_date: null,
};

@Component
export default class ApproveHOPopUp extends Vue {
  @Prop({ type: Boolean, default: true }) readonly visible!: boolean;

  get serviceId(): number {
    return Number(this.$route.params.id ?? 0);
  }

  get isSponsorLicenceCase() {
    return SMCases.caseType === SPONSOR_LICENCE_SERVICE_TYPE;
  }

  get text() {
    return this.isSponsorLicenceCase ? this.$tc("text.sl") : this.$tc("text.notSL");
  }

  get buttonCaption() {
    return this.isSponsorLicenceCase ? this.$tc("buttons.ok") : this.$tc("buttons.confirm");
  }

  showPopup = false;

  get showDatesSelect() {
    return !this.isSponsorLicenceCase;
  }

  @Watch("visible", { immediate: true })
  visibleChanged(val: boolean) {
    if (val) {
      this.open();
    } else {
      this.showPopup = false;
    }

    if (!val) this.form = { ...FORM };
  }

  open() {
    this.showPopup = false;

    this.$nextTick(() => {
      this.showPopup = true;
    });
  }

  form = { ...FORM };

  get confirmDisabled() {
    if (this.isSponsorLicenceCase) return false;

    const { visa_start_date, visa_end_date } = this.form;

    return !!(!visa_start_date || !visa_end_date || !this.serviceId);
  }

  close() {
    this.showPopup = false;

    this.$emit("close");
  }

  async confirm() {
    try {
      const params = { ...this.form };

      await this.axios.put(API_ROUTES.CASE_EXPERT_HO_APPROVE(this.serviceId), params);

      this.$emit("confirm");

      this.$root.$emit("update-profile");

      SMCases.setOnlineApplicationStatus(APPROVED_BY_HO_OA_STATUS);
    } finally {
      this.close();
    }
  }
}
